import React from 'react';
import './SpecialEvent.css';

const SpecialEvent = ({ currentLanguage }) => {
  const getTranslation = (key) => {
    const translations = {
      en: {
        title: 'Hospital Shilanyas (Foundation Stone Laying) Ceremony with the Honorable President of India'
      },
      hi: {
        title: 'भारत के माननीय राष्ट्रपति (श्रीमती) द्रौपदी मुर्मू के गरिमामय उपस्थिति में नए अस्पताल का शिलान्यास समारोह'
      },
      gu: {
        title: 'ભારતના માનનીય રાષ્ટ્રપતિ (શ્રીમતી) દ્રૌપદી મુર્મુની ઉપસ્થિતિમાં નવી હોસ્પિટલનો શિલાન્યાસ સમારોહ'
      }
    };
    return translations[currentLanguage]?.[key] || translations.en[key];
  };

  const specialEventImages = [
    '/images/events/special_event/(1).JPG',
    '/images/events/special_event/(9).JPG',
    '/images/events/special_event/(3).JPG'
  ];

  return (
    <section id="special-event" className="special-event">
      <div className="container">
        <div className="special-event-header">
          <h2 className="special-event-title">{getTranslation('title')}</h2>
        </div>
        
        <div className="special-event-grid">
          <div className="special-event-item large">
            <div className="special-event-image">
              <img src={specialEventImages[0]} alt="Presidential Event Main" />
            </div>
          </div>
          
          <div className="special-event-remaining">
            <div className="special-event-item">
              <div className="special-event-image">
                <img src={specialEventImages[1]} alt="Presidential Event 2" />
              </div>
            </div>
            <div className="special-event-item">
              <div className="special-event-image">
                <img src={specialEventImages[2]} alt="Presidential Event 3" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SpecialEvent;
